export default __webpack_public_path__ + "static/media/russian poker-03.91fc6f1d.png";